// extracted by mini-css-extract-plugin
export default {"couponModal":"coupons-modal_couponModal__ZmN3o"};